import React, { useState, useEffect } from 'react';
import Corporate_identity from './components/corporate_identity';
import Business from './components/business';
import Representative from './components/representative';
import Company from './components/company';
import Recruit from './components/recruit';
import Contact from './components/contact';
import Header from './components/Header';
import { Box } from '@mui/material';
import PageScroller from 'react-page-scroller';

const App = () => {
  const [current, setCurrent] = useState(0);

  const scrollToSection = (id: string) => {
    switch (id) {
      case 'section1':
        setCurrent(0);
        break;
      case 'section2':
        setCurrent(1);
        break;
      case 'section3':
        setCurrent(2);
        break;
      case 'section4':
        setCurrent(3);
        break;
      case 'section5':
        setCurrent(4);
        break;
      case 'section6':
        setCurrent(5);
        break;
      default:
        break;
    }

  };

  return (
    <div className="background-container">
      <Header scrollToSection={scrollToSection} />
      <PageScroller
        pageOnChange={(number: number) => setCurrent(number)}
        customPageNumber={current}
        animationTimer={1500}
        animationTimerBuffer={300}
      >
        <Box
          id="section1"
          className="section"
          sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
        >
          <Corporate_identity />
        </Box>
        <Box
          id="section2"
          className="section"
          sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
        >
          <Business />
        </Box>
        <Box
          id="section3"
          className="section"
          sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
        >
          <Representative />
        </Box>
        <Box
          id="section4"
          className="section"
          sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
        >
          <Company />
        </Box>
        <Box
          id="section5"
          className="section"
          sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
        >
          <Recruit />
        </Box>
        <Box
          id="section6"
          className="section"
          sx={{ height: '100vh' }}
        >
          <Contact />
        </Box>
      </PageScroller>
    </div>
  );
};

export default App;
